<div class="cinturon-indicator" 
     [ngStyle]="getCinturonStyle()"
     [class.small]="size === 'small'"
     [class.medium]="size === 'medium'"
     [class.large]="size === 'large'"
     [title]="getGraduacionDescripcion()">
</div>